import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

const BackUrlHandler = () => {
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const backUrl = params.get('backUrl');
    if (!backUrl) {
      return;
    }
    params.delete('backUrl');

    const newLocation = {
      pathname: location.pathname,
      state: location.state,
      search: `?${params.toString()}`,
    };

    history.replace(backUrl);
    history.push(newLocation);
  }, [location, history]);

  return null;
};

export default BackUrlHandler;
